import { useSearchParams, useLocation, useNavigationType } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import { buildSearchParams, getFilters } from './filters'

const DEFAULT_PAGINATION = { pageSize: 25, page: 0 }

const useFilterParams = ({
  columns,
  defaultFilters,
}) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { pathname, key: locationKey } = useLocation()
  const navigationType = useNavigationType()
  const mounted = useRef(false)
  const [filters, setFilters] = useState({
    items: [],
    logicOperator: 'and',
  })
  const [sortParams, setSortParams] = useState([])
  const [paginationParams, setPaginationParams] = useState({
    pageSize: 25,
    page: 0,
  })
  const filterFields = columns.map((column) => column.field)

  useEffect(() => {
    const currentFilters = getFilters(searchParams, defaultFilters, pathname, filterFields, paginationParams)
    setSearchParams(buildSearchParams(currentFilters, pathname, [{
      sort: currentFilters.sort.sort,
      field: currentFilters.sort.field,
    }], currentFilters.pagination))
    setFilters(currentFilters)
    setSortParams([currentFilters.sort])
    setPaginationParams(currentFilters.pagination)
  }, [])

  // Grid changes write the URL themselves, and a half-typed filter row is absent from the URL, so only a browser
  // Back/Forward (POP) re-reads the URL into state; syncing on every change would wipe rows the user is still editing.
  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true
      return
    }
    if (navigationType !== 'POP') {
      return
    }
    const urlFilters = getFilters(searchParams, defaultFilters, pathname, filterFields, DEFAULT_PAGINATION)
    setFilters(urlFilters)
    setSortParams(urlFilters.sort?.field ? [urlFilters.sort] : [])
    setPaginationParams(urlFilters.pagination?.page === undefined ? DEFAULT_PAGINATION : urlFilters.pagination)
  }, [locationKey])

  return {
    filters,
    setFilters,
    setSearchParams,
    sortParams,
    setSortParams,
    paginationParams,
    setPaginationParams,
  }
}

export default useFilterParams
